export default function ZzzfunAbout() {
  return (
    <section id="zzzfun-about" className="scroll-mt-24 bg-secondary-50 py-16 dark:bg-background-100 md:py-24">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          {/* 吉祥物 */}
          <div className="flex justify-center lg:justify-start">
            <div className="relative">
              <div className="absolute -inset-6 rounded-full bg-primary-100/60 blur-3xl" />
              <div className="relative h-[300px] w-[300px] overflow-hidden sm:h-[380px] sm:w-[380px]">
                <img
                  src="/images/zzzfun-mascot.png"
                  alt="ZzzFun官方吉祥物"
                  title="ZzzFun动漫官网下载 - 官方吉祥物"
                  className="h-full w-full object-contain"
                />
              </div>
            </div>
          </div>

          {/* 文案 */}
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-accent-600">About</span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">关于ZzzFun</h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              ZzzFun是一款专注于番剧观看的播放工具，以兴趣推荐为核心，帮助每一位动漫爱好者更快找到想看的作品。打开客户端，排行榜、新番时间表与分区内容清晰呈现，看番从此不再费心。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              无论你是资深追番党，还是刚刚入坑的新人，都能在这里获得流畅的观看体验。想要体验全部功能，可通过ZzzFun、ZzzFun动漫官网下载、ZzzFun官方APP免费下载等方式获取客户端，随时开启高清无广告的追番之旅。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
              <div className="flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-4">
                <i className="ri-emotion-happy-line text-2xl text-primary-600" />
                <span className="text-sm font-medium text-foreground-800">轻松上手的界面</span>
              </div>
              <div className="flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-4">
                <i className="ri-heart-3-line text-2xl text-accent-600" />
                <span className="text-sm font-medium text-foreground-800">以兴趣为推荐核心</span>
              </div>
              <div className="flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-4">
                <i className="ri-rocket-2-line text-2xl text-secondary-600" />
                <span className="text-sm font-medium text-foreground-800">快速更新海量番剧</span>
              </div>
              <div className="flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-4">
                <i className="ri-shield-star-line text-2xl text-primary-600" />
                <span className="text-sm font-medium text-foreground-800">安全无捆绑下载</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}